import { TabProps } from './tabs.model'

export const Tab = ({ children }: TabProps) => <>{children}</>
